// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"668":"3e7a10b7","738":"f5fa1d2a","760":"bec83f67","787":"ed33805e"}[chunkId] + ".chunk.js";
};